/**
 * Matches a URL that lives on one of `domains` (any sub-domain of them included, so
 * `acme.slack.com` and `yourname.substack.com` pass), with or without a protocol.
 * `constants/socialBrands` holds the domain list for each network.
 */
export const socialUrlPattern = (domains: string[]) =>
  new RegExp(
    `^(?:https?:\\/\\/)?(?:[\\w-]+\\.)*(?:${domains
      .map((domain) => domain.replace(/\./g, '\\.'))
      .join('|')})(?:[/?#].*)?$`,
    'i'
  )

export const HEX_REGEX = /^#([0-9A-F]{3}){1,2}$/i

export const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/

export const URL_REGEX =
  /^(https?:\/\/)?(?:[\da-z](?:[\da-z.-]*[\da-z])?\.)+[a-z]{2,63}(?:[/?#][^\s]*)?$/i
export const URL_MATCH_REGEX =
  /(?:https?:\/\/|www\.)[^\s<]+|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:[/?#][^\s<]*)?/g

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
